<div
  class="ddc-read-word-mobile-sheet"
  [ngClass]="{
    'dark-theme': _isDarkTheme,
    'light-theme': _isLightTheme,
    'paper-theme': _isPaperTheme,
  }"
>
  <!-- Header with word title and privacy -->
  <div class="sheet-header">
    <div class="header-left">
      <ddc-text-gradient
        class="text-xl"
        [_icon]="'fiber_smart_record'"
        [_text]="'Pair'"
        [_type]="'1'"
      ></ddc-text-gradient>
      <div class="content-row dictionaries" *ngIf="pair()?.dictionaries?.length">
        <ddc-dic-s
          class="dictionary-item"
          *ngFor="let dic of pair()?.dictionaries | slice: 0 : 3"
          [label]="dic.title"
        ></ddc-dic-s>
      </div>
      <ddc-privacy [code]="pair()?.word_1.privacy" [withText]="false"></ddc-privacy>
    </div>
    <div class="header-right" *ngIf="pair()?.word_1.privacy">
      <!-- Dictionaries row -->
      <div style="display: flex; gap: 15px">
        <ddc-country-flag [ddc_lng]="pair().word_1.language" [has_label]="false"></ddc-country-flag>
        <ddc-country-flag [ddc_lng]="pair().word_2.language" [has_label]="false"></ddc-country-flag>
      </div>
    </div>
  </div>

  <mat-divider></mat-divider>

  <!-- Content section -->
  <div class="sheet-content">
    <!-- Word details row -->
    <ddc-profile-pic
      [dynamicRoute]="'/users/' + pair()?.owner?.username"
      [followerCount]="pair()?.owner?.followers_count"
      [minimal]="true"
      [subscription]="pair()?.owner?.subscription"
      [username]="pair()?.owner?.username"
      [userProfilePic]="pair()?.owner?.profile_pic"
      (click)="onProfilePicClick()"
    ></ddc-profile-pic>
    <div style="display: flex; gap: 5px">
      @if (pair().word_1.category !== undefined && pair().word_1.category?.label.length > 0) {
        <ddc-card-category [category]="pair().word_1.category.label"></ddc-card-category>
      }
      @if (pair().word_2.category !== undefined && pair().word_2.category?.label.length > 0) {
        <ddc-card-category [category]="pair().word_2.category.label"></ddc-card-category>
      }
    </div>
    <div class="content-row word-details">
      <span class="word-article" *ngIf="pair().word_1.article">{{ pair().word_1.article }}</span>
      <span class="word-text">{{ pair().word_1.word }}</span>
      <span class="word-pos" *ngIf="pair().word_1.pos">[{{ pair().word_1.pos }}]</span>
    </div>
    <div class="content-row word-details">
      <span class="word-article" *ngIf="pair().word_2.article">{{ pair().word_2.article }}</span>
      <span class="word-text">{{ pair().word_2.word }}</span>
      <span class="word-pos" *ngIf="pair().word_2.pos">[{{ pair().word_2.pos }}]</span>
    </div>

    <!-- Definition section -->
    <div class="content-row" *ngIf="pair()?.word_1.definition">
      <div class="section-header">
        <mat-icon>description</mat-icon>
        <span>Definitions</span>
      </div>
      <div class="section-content">{{ pair()?.word_1.definition }}</div>
      <div class="section-content">{{ pair()?.word_2.definition }}</div>
    </div>

    <!-- Example section -->
    <div class="content-row" *ngIf="pair()?.word_1.example">
      <div class="section-header">
        <mat-icon>format_quote</mat-icon>
        <span>Examples</span>
      </div>
      <div class="section-content">{{ pair()?.word_1.example }}</div>
      <div class="section-content">{{ pair()?.word_2.example }}</div>
    </div>

    <!-- Tags section -->
    <div class="content-row tags" *ngIf="pair()?.word_2.tags?.length || pair()?.word_1.tags?.length">
      <div class="section-header">
        <mat-icon>local_offer</mat-icon>
        <span>Tags</span>
      </div>
      <div class="tags-container">
        <span class="tag-item" *ngFor="let tag of pair()?.word_1.tags">{{ tag.label }}</span>
        <span class="tag-item" *ngFor="let tag of pair()?.word_2.tags">{{ tag.label }}</span>
      </div>
    </div>
  </div>
</div>
